import { render, staticRenderFns } from "./VideoCallManagement.vue?vue&type=template&id=7db09883"
import script from "./VideoCallManagement.vue?vue&type=script&lang=js"
export * from "./VideoCallManagement.vue?vue&type=script&lang=js"
import style0 from "./VideoCallManagement.vue?vue&type=style&index=0&id=7db09883&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports